
export const filterMenu = (menu, roles) => {
  const normalizedRoles = roles.map((role) =>
    String(role).trim().toUpperCase()
  );

  const hasPermission = (permission) => {
    // No permission = available to everyone
    if (!permission) {
      return true;
    }

    const permissions = Array.isArray(permission)
      ? permission
      : [permission];

    return permissions.some((item) =>
      normalizedRoles.includes(String(item).trim().toUpperCase())
    );
  };

  return menu
    .map((item) => {
      // --------------------------------------------------
      // Parent permission
      // --------------------------------------------------
      const parentAllowed = hasPermission(item.permission);

      // --------------------------------------------------
      // If parent itself has permission and user doesn't
      // have it, don't show the menu at all.
      // --------------------------------------------------
      if (item.permission && !parentAllowed) {
        return null;
      }

      // --------------------------------------------------
      // Filter children
      // --------------------------------------------------
      if (item.children) {
        const filteredChildren = item.children.filter((child) =>
          hasPermission(child.permission)
        );

        // If parent has children but none are accessible,
        // don't show the parent.
        if (filteredChildren.length === 0) {
          return null;
        }

        return {
          ...item,
          children: filteredChildren,
        };
      }

      // --------------------------------------------------
      // Normal menu item
      // --------------------------------------------------
      return parentAllowed ? item : null;
    })
    .filter(Boolean);
};

